module.exports = __webpack_public_path__ + "static/media/student-overview-background.f863f93a.jpg";